import { Injectable } from 'angular-ts-decorators';
import { IGiftWrappingConfiguration } from './models/gift-wrapping.configuration';

@Injectable('giftWrappingApiService')
export class GiftWrappingApiService {
  public static $inject: ReadonlyArray<string> = ['$http'];

  constructor(private $http: ng.IHttpService) { }

  public getGiftWrapping(): ng.IPromise<IGiftWrappingConfiguration> {
    const url = `/public-api/gift-wrapping/configuration`;

    return this.$http
      .get<IGiftWrappingConfiguration>(url)
      .then((response: ng.IHttpResponse<IGiftWrappingConfiguration>) => response.data);
  }
}
